import styled from 'styled-components';
import { Colors, fonts } from '../style/GlobalStyles';

const CTAButton = styled.button`
  font-family: ${fonts.body};
  padding: 1rem 2.2rem;
  border-radius: 999px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.25s ease, background 0.25s ease, color 0.25s ease;
  white-space: nowrap;

  &:hover {
    transform: translateY(-2px);
  }
`;

// Botón con borde (sobre fondo crema)
const CTAButtonOutline = styled(CTAButton)`
  background: transparent;
  color: ${Colors.ink};
  border: 1.5px solid ${Colors.ink};

  &:hover {
    background: ${Colors.ink};
    color: ${Colors.paper};
  }
`;

function ButtonOut({ text, onClick }) {
  return <CTAButtonOutline onClick={onClick}>{text}</CTAButtonOutline>;
}

export { ButtonOut, CTAButtonOutline };
